module.exports = __webpack_public_path__ + "448ef02cf20187b8dd1dc6f110c20e64.svg";